import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

function mapDispatchToProps(actions, dispatch) {
    return bindActionCreators(actions, dispatch);
}

export default (component, actions={}, mapStateToProps)=>{
    return withRouter(connect(mapStateToProps, mapDispatchToProps.bind(this, actions))(component));
}



// WEBPACK FOOTER //
// ./src/store/connect.js